import { render, staticRenderFns } from "./MapaDeSeparacao.vue?vue&type=template&id=dfcfc1d2"
import script from "./MapaDeSeparacao.vue?vue&type=script&lang=js"
export * from "./MapaDeSeparacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports